export enum MergeMissingResolve {
  COPY = 'COPY',
  SKIP = 'SKIP',
  ABORT = 'ABORT'
}

export enum MergeTypeMismatchResolve {
  KEEP = 'KEEP',
  SKIP = 'SKIP',
  ABORT = 'ABORT'
} 